<template>
  <v-dialog v-model="show" fullscreen hide-overlay>
    <template v-slot:activator="{ on: dialog, attrs }">
      <v-tooltip bottom transition="none" color="black">
        <template v-slot:activator="{ on: tooltip }">
          <v-btn
            icon depressed
            @click="show=true"
            v-bind="attrs"
            v-on="{ ...tooltip, ...dialog }"
            :disabled="disabled"
          >
            <v-icon>mdi-printer</v-icon>
          </v-btn>
        </template>
        <span>Print Analysis</span>
      </v-tooltip>
    </template>
    <v-card flat tile>
      <v-toolbar flat tile color="success">
        <v-toolbar-title>Holdback Analysis</v-toolbar-title>
        <v-spacer/>
        <v-btn depressed @click="onSubmit" class="d-print-none">Print</v-btn>
        <v-btn icon @click="show=false" class="d-print-none"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>

      <v-card flat tile>
        
        <v-card-title>Aggregates</v-card-title>
        <v-row>
          <v-col cols="4">
            <vue-plotly
              v-if="!isEmpty(charts.timeline.data)"
              :data="charts.timeline.data"
              :layout="charts.timeline.layout"
              :options="charts.timeline.options"
            />
          </v-col>
        </v-row>


      </v-card>

    </v-card>
  </v-dialog>
</template>
<script>
import Holdback from "@/api/holdback"
import VuePlotly from '@statnett/vue-plotly'
export default {
  name: "PrintAnalysis",
  props: {
    payload: { type: Object, required: true },
    methods: { type: Array, required: true },
    disabled: { type: Boolean, default: false },
  },
  components: { VuePlotly },
  data() {
    return {
      show: false,
      timeline: null,
      original: null,
      colors: {
        oil: "#616161",
        gas: "#4CAF50",
        water: "#03A9F4",
        arps1: "#F44336",
        advanced3a: "#2196F3",
        advanced5: "#2196F3",
        multi3a: "#FF9800",
        multi5: "#FF9800",
        hyper5: "#9C27B0",
        hyper5a: "#1B5E20",
      },
      charts: {
        timeline: {
          data: [],
          layout: {
            autosize: true,
            barmode: "relative",
            showlegend: true,
            height: 300,
            legend: { x: 1, y: 1, xanchor: "right", bgcolor: "#FFF" },
            font: { family: "Roboto, sans-serif", color: "#808080" },
            hovermode: "closest",
            margin: { l: 60, t: 0, r: 15, b: 45 },
            xaxis: { title: { text: `Time (months)` }, dtick: 12 },
            yaxis: { title: { text: `Production` }, type: "linear" },
            paper_bgcolor: "rgba(0,0,0,0)",
            plot_bgcolor: "rgba(0,0,0,0)"
          },
          options: { displayModeBar: false, responsive: true, staticPlot: true }
        }
      }
    }
  },
  watch: {
    show: function() {
      this.fetchTimeline()
    }
  },
  methods: {
    onSubmit() {
      window.print()
    },
    fetchTimeline() {
      Holdback.get_timeline(this.payload.normal, this.payload).then(response => {
        this.timeline = response.data
        this.plotTimeline()
      })
    },
    plotTimeline() {
      this.charts.timeline.data = []

      // Plot actual production and declines
      this.charts.timeline.data.push({
        name: 'Production',
        type: "bar",
        showlegend: true,
        x: this.create_array(1, this.timeline['production'].length),
        y: this.timeline['production'],
        marker: { color: this.colors[this.payload.target], opacity: 0.5 }
      })
      
      this.charts.timeline.data.push({
        name: 'Decline',
        type: "scatter",
        mode: 'lines',
        showlegend: true,
        x: this.create_array(1, this.timeline['production'].length + 12),
        y: this.timeline['decline'],
        line: { color: '#F4433680', dash: 'solid', width: 1, opacity: 0.5 }
      })

      // Plot holdback production
      this.charts.timeline.data.push({
        name: this.payload.target,
        type: "bar",
        showlegend: false,
        x: this.create_array(this.timeline['production'].length + 1, this.timeline['production'].length + 12),
        y: this.timeline['holdback'],
        marker: { color: this.colors[this.payload.target], opacity: 0.25 }
      })

      // Plot predictions
      this.methods.forEach(method => {
        this.charts.timeline.data.push({
          name: method.text,
          type: "scatter",
          mode: 'lines',
          showlegend: true,
          x: this.create_array(this.timeline['production'].length + 1, this.timeline['production'].length + 12),
          y: this.timeline[`${this.payload.target}_${method.value}`],
          line: { color: this.colors[method.value], dash: 'dot', width: 1 }
        })
      })
    },
  },
}
</script>